<section class="footer-simple">
  <!-- Footer -->
  <footer class="bg-body-tertiary text-center">
    <!-- Grid container -->
    <div class="container footer-container" *ngIf="!isOnSupportPage()">
      <!-- Footer content with responsive layout -->
      <div class="row align-items-center footer-content">
        <!-- Social media links -->
        <div class="col-12 col-md-3 text-center text-md-start mb-3 mb-md-0 instagram-section">
          <div class="d-flex align-items-center justify-content-center justify-content-md-start gap-2">
              <a href="https://www.instagram.com/altastudio.ver/" class="text-body social-link instagram-icon" target="_blank">
                <i class="fa-brands fa-instagram"></i>
              </a>
            <a href="https://www.instagram.com/altastudio.ver/" class="text-body footer-link footer-text" target="_blank">¡Síguenos en Instagram!</a>
          </div>
        </div>
        
        <!-- Navigation links -->
        <div class="col-12 col-md-9 text-center text-md-end navigation-section">
          <ul class="list-inline mb-0 footer-nav">
            <li class="list-inline-item mx-1 mx-md-2">
              <a class="text-body footer-link footer-text" (click)="scrollToTop()" style="cursor: pointer;">Inicio</a>
            </li>
            <li class="list-inline-item mx-1 mx-md-2">
              <span class="footer-separator">|</span>
            </li>
            <li class="list-inline-item mx-1 mx-md-2">
              <a class="text-body footer-link footer-text" (click)="scrollToSection('app-pricing')" style="cursor: pointer;">Planes</a>
            </li>
            <!-- <li class="list-inline-item mx-1 mx-md-2">
              <span class="footer-separator">|</span>
            </li> -->
            <!-- <li class="list-inline-item mx-1 mx-md-2">
              <a href="/support" class="text-body footer-link footer-text">Soporte</a>
            </li> -->
            <li class="list-inline-item mx-1 mx-md-2">
              <span class="footer-separator">|</span>
            </li>
            <li class="list-inline-item mx-1 mx-md-2">
              <a href="/auth/login" class="text-body footer-link footer-text">Inicio de sesión</a>
            </li>
            <li class="list-inline-item mx-1 mx-md-2">
              <span class="footer-separator">|</span>
            </li>
            <li class="list-inline-item mx-1 mx-md-2">
              <a href="/terms-and-conditions" class="text-body footer-link footer-text">Términos y condiciones</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- Grid container -->
 
    <!-- Copyright -->
    <div class="text-center p-3 copyright-section">
     Tudi {{currentYear}} © Copyright
    </div>
    <!-- Copyright -->
  </footer>
  <!-- Footer -->
</section>